import { StrictMode } from "react";
import { AppRoutes } from "./routes.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SessionProvider } from "@/platform/auth";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BreadcrumbProvider } from "@/platform/navigation";

const queryClient = new QueryClient();
const queryDevtoolsEnabled =
  import.meta.env.DEV && import.meta.env.VITE_ENABLE_QUERY_DEVTOOLS === "true";

export function App() {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {queryDevtoolsEnabled && <ReactQueryDevtools />}
        <BreadcrumbProvider>
          <SessionProvider>
            <AppRoutes />
          </SessionProvider>
        </BreadcrumbProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}
